import { useAppTranslation } from 'app/hooks';
import { GameResponseModel, OddModel } from 'models';
import React, { Fragment, useState } from 'react';
import { AiFillCaretDown, AiFillCaretUp } from 'react-icons/ai';
import InactiveButton from '../InactiveButton';
import OddButton from 'features/home/layouts/components/OddButton';

interface WagerItemProps {
  game: GameResponseModel;
  // status: { [key: string]: string };
  title: string;
  type?: string;
  odds: OddModel[];
  category: string;
}

const WagerItem: React.FunctionComponent<WagerItemProps> = ({
  game,
  // status,
  title,
  type = 'alternate',
  odds,
  category,
}) => {
  const t = useAppTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onOpenClick = (): void => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="wager-list">
      <div className="wager-list__item">
        <div className="header" onClick={onOpenClick}>
          <span className="wager__name">{title}</span>
          <div className="header__right">
            <button type="button">{isOpen ? <AiFillCaretUp /> : <AiFillCaretDown />}</button>
          </div>
        </div>
        {isOpen && (
          <div className="content">
            <div className="row">
              <span className="row__name">
                {type === 'first half' ? game.awayTeam : t('alternateTotalPoints.over')}
              </span>
              <div className="row__right--first-half">
                {odds.length === 0 ? (
                  <InactiveButton />
                ) : (
                  <Fragment>
                    <OddButton
                      key={`${odds[0].id}`}
                      odd={odds[0]}
                      index={0}
                      gameId={game.id}
                      homeTeam={game.homeTeam}
                      awayTeam={game.awayTeam}
                      category={category}
                      // isShowAnimation={status[odds[0].id]}
                      homeTeamLogo={game.homeTeamLogo}
                      awayTeamLogo={game.awayTeamLogo}
                      gameStatus={game.status}
                    />
                  </Fragment>
                )}
              </div>
            </div>
            <div className="row">
              <span className="row__name">
                {type === 'first half' ? game.homeTeam : t('alternateTotalPoints.under')}
              </span>
              <div className="row__right--first-half">
                {odds.length === 0 ? (
                  <InactiveButton />
                ) : (
                  <Fragment>
                    <OddButton
                      key={`${odds[1].id}`}
                      odd={odds[1]}
                      index={1}
                      gameId={game.id}
                      homeTeam={game.homeTeam}
                      awayTeam={game.awayTeam}
                      category={category}
                      // isShowAnimation={status[odds[1].id]}
                      homeTeamLogo={game.homeTeamLogo}
                      awayTeamLogo={game.awayTeamLogo}
                      gameStatus={game.status}
                    />
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WagerItem;
